{
  "version": "1.2.6",
  "objects": {
    "7493635533076610675": {
      "type": "frame",
      "id": "7493635533076610675",
      "z": 1366,
      "textContent": "",
      "left": -309.20154594827414,
      "top": 1387.9872161359644,
      "width": 400,
      "height": 500,
      "scaleX": 1.7891426161574897,
      "scaleY": 1.201211144067714,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 30,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7493635533074496548": {
      "type": "frame",
      "id": "7493635533074496548",
      "z": 1376,
      "textContent": "Frame 24",
      "left": 71.37911161767005,
      "top": 1407.9872161359644,
      "width": 400,
      "height": 500,
      "scaleX": 0.7876909722426294,
      "scaleY": 1.121211144067714,
      "fill": "#3AA68A",
      "opacity": 0.05,
      "container": "7493635533076610675",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": "auto",
      "layoutPadding": 100,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533082313398": {
      "type": "frame",
      "id": "7493635533082313398",
      "z": 1386,
      "textContent": "Frame 23",
      "left": -289.20154594827414,
      "top": 1407.9872161359644,
      "width": 400,
      "height": 500,
      "scaleX": 0.8264516439148605,
      "scaleY": 1.121211144067714,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533076610675",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "parent",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533077006798": {
      "type": "frame",
      "id": "7493635533077006798",
      "z": 1396,
      "textContent": "Frame 46",
      "left": -195.91121716530205,
      "top": 1437.9872161359644,
      "width": 400,
      "height": 500,
      "scaleX": 0.36,
      "scaleY": 0.118,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533082313398",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533080245469": {
      "type": "shape",
      "id": "7493635533080245469",
      "z": 1866,
      "shapeName": "text",
      "textContent": "<p>Welcome back</p>",
      "left": -195.91121716530205,
      "top": 1437.9872161359644,
      "width": 101.267461925906,
      "height": 29.53634306172259,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.4219769831435092,
      "scaleY": 1.421976983143509,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 19.90767776400913,
      "angle": 0,
      "container": "7493635533077006798",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7493635533079964965": {
      "type": "shape",
      "id": "7493635533079964965",
      "z": 1876,
      "shapeName": "text",
      "textContent": "<p>Welcome back!</p>",
      "left": -153.41121716530205,
      "top": 1479.9872161359644,
      "width": 105.49174822968062,
      "height": 30.39592745600967,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.5592854511382537,
      "scaleY": 0.5592854511382537,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 7.829996315935551,
      "angle": 0,
      "container": "7493635533077006798",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7493635533080865663": {
      "type": "frame",
      "id": "7493635533080865663",
      "z": 1406,
      "textContent": "Frame 45",
      "left": -258.40546108692473,
      "top": 1825.208990871969,
      "width": 400,
      "height": 500,
      "scaleX": 0.6724712196081134,
      "scaleY": 0.22676759459570486,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533082313398",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 3,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533072108658": {
      "type": "wireframe",
      "id": "7493635533072108658",
      "z": 1836,
      "top": 1828.208990871969,
      "left": -255.40546108692473,
      "width": 331.4063879045013,
      "height": 39.859375,
      "scaleX": 0.7935528627137647,
      "scaleY": 0.7935528627137646,
      "container": "7493635533080865663",
      "layoutPosition": "a4",
      "wireframeName": "button",
      "fill": "#3AA78B",
      "textColor": null,
      "style": "roundFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Login" },
      "setDimension": true
    },
    "7493635533074609562": {
      "type": "wireframe",
      "id": "7493635533074609562",
      "z": 1846,
      "top": 1869.8395120092005,
      "left": -254.9303303857311,
      "width": 327.035610832171,
      "height": 39.859375,
      "scaleX": 0.8012528842778885,
      "scaleY": 0.8012528842778885,
      "container": "7493635533080865663",
      "layoutPosition": "a5",
      "wireframeName": "button",
      "fill": "#3AA78B",
      "textColor": null,
      "style": "round",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Register" },
      "setDimension": true
    },
    "7493635533087641228": {
      "type": "wireframe",
      "id": "7493635533087641228",
      "z": 1856,
      "top": 1911.7769511934644,
      "left": -166.2081628682215,
      "width": 120.2685546875,
      "height": 33.859375,
      "scaleX": 0.703374972998084,
      "scaleY": 0.703374972998084,
      "container": "7493635533080865663",
      "layoutPosition": "a6",
      "wireframeName": "link",
      "fill": "#808080",
      "textColor": null,
      "style": "link",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Forgot password" }
    },
    "7493635533086305383": {
      "type": "frame",
      "id": "7493635533086305383",
      "z": 1456,
      "textContent": "Frame 46",
      "left": -259.20154594827414,
      "top": 1516.9872161359644,
      "width": 400,
      "height": 500,
      "scaleX": 0.6764516439148605,
      "scaleY": 0.5764435494720092,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533082313398",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "parent",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7493635533078644996": {
      "type": "frame",
      "id": "7493635533078644996",
      "z": 1466,
      "textContent": "Frame 30",
      "left": -259.20154594827414,
      "top": 1553.4527366620666,
      "width": 400,
      "height": 500,
      "scaleX": 0.6764516439148605,
      "scaleY": 0.1,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533086305383",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "ZzV",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7493635533085110323": {
      "type": "wireframe",
      "id": "7493635533085110323",
      "z": 2036,
      "top": 1563.4527366620666,
      "left": -194.289830233921,
      "width": 170.2890625,
      "height": 39.859375,
      "scaleX": 0.8207058285803761,
      "scaleY": 0.8207058285803762,
      "container": "7493635533078644996",
      "layoutPosition": "a0",
      "wireframeName": "multiSelect",
      "fill": "#3AA78B",
      "itemsData": {
        "7483618070729429166": {
          "id": "7483618070729429166",
          "value": "Sign up",
          "item_position": 0
        },
        "7483618070735350820": {
          "id": "7483618070735350820",
          "state": "selected",
          "value": "Sign in",
          "item_position": 1000000
        }
      },
      "textColor": "#FFFFFF",
      "style": "square",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "showIcons": true
    },
    "7493635533079396791": {
      "type": "wireframe",
      "id": "7493635533079396791",
      "z": 1806,
      "top": 1623.4527366620666,
      "left": -259.20154594827414,
      "width": 270.5806575659442,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7493635533086305383",
      "layoutPosition": "a0",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Email", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Email ",
        "iconLeft": { "prefix": "fas", "iconName": "envelopes-bulk" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7493635533075921982": {
      "type": "wireframe",
      "id": "7493635533075921982",
      "z": 1816,
      "top": 1683.4527366620666,
      "left": -259.20154594827414,
      "width": 270.12312697149355,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7493635533086305383",
      "layoutPosition": "a1",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Password",
        "iconLeft": { "prefix": "fas", "iconName": "key" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7493635533087288706": {
      "type": "wireframe",
      "id": "7493635533087288706",
      "z": 1826,
      "top": 1743.4527366620666,
      "left": -259.20154594827414,
      "width": 124.5791015625,
      "height": 24,
      "scaleX": 0.9287805701583373,
      "scaleY": 0.9287805701583373,
      "container": "7493635533086305383",
      "layoutPosition": "a2",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#9D9D9D",
      "componentState": "empty",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Remember me", "position": "right" },
      "placeholder": {}
    }
  }
}
